function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.12 70.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M57.17,7.18m5.95,13.34V65a5.45,5.45,0,0,1-5.44,5.44l-44.32-.33a5.44,5.44,0,0,1-5.43-5.44V59.49h2.65v5.13a2.8,2.8,0,0,0,2.79,2.8l44.32.33A2.81,2.81,0,0,0,60.48,65V23.13H46.27a6,6,0,0,1-6-5.95V3l-27-.31a2.77,2.77,0,0,0-2.75,2.78V35.69H7.93V5.42A5.42,5.42,0,0,1,13.35,0l29,.33h.62Zm-3.85,0L43,4.18v13a3.31,3.31,0,0,0,3.31,3.31Z",
    style: {
      fill: "#aaa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 38.34,
    width: 55.4,
    height: 19.39,
    rx: 2.54,
    style: {
      fill: "#6aaba3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.11,53.65a1.43,1.43,0,0,1-.42-1.08V44.82H12.37a1.6,1.6,0,0,1-1.08-.31,1.4,1.4,0,0,1,0-1.85,1.66,1.66,0,0,1,1.08-.3h7.7a1.62,1.62,0,0,1,1.08.3,1.37,1.37,0,0,1,0,1.85,1.57,1.57,0,0,1-1.08.31H17.75v7.75a1.43,1.43,0,0,1-.42,1.08,1.71,1.71,0,0,1-2.22,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.34,52.69a1.33,1.33,0,0,1-.44,1,1.37,1.37,0,0,1-1,.42,1.29,1.29,0,0,1-1-.5L27.09,50.2l-2.88,3.39a1.3,1.3,0,0,1-1,.5,1.49,1.49,0,0,1-1.42-1.42,1.37,1.37,0,0,1,.35-.89l3.16-3.65-3.08-3.58a1.35,1.35,0,0,1-.36-.88,1.31,1.31,0,0,1,.43-1,1.41,1.41,0,0,1,1-.42,1.31,1.31,0,0,1,1,.49l2.78,3.29,2.76-3.29a1.21,1.21,0,0,1,1-.49,1.39,1.39,0,0,1,1,.42,1.32,1.32,0,0,1,.44,1,1.35,1.35,0,0,1-.35.88l-3.08,3.58L32,51.78A1.37,1.37,0,0,1,32.34,52.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.81,53.65a1.43,1.43,0,0,1-.42-1.08V44.82H34.07A1.6,1.6,0,0,1,33,44.51a1.4,1.4,0,0,1,0-1.85,1.66,1.66,0,0,1,1.08-.3h7.7a1.62,1.62,0,0,1,1.08.3,1.37,1.37,0,0,1,0,1.85,1.57,1.57,0,0,1-1.08.31H39.45v7.75A1.43,1.43,0,0,1,39,53.65a1.71,1.71,0,0,1-2.22,0Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/text_icon.69236d7ae8abe698292e0a0f1d4ecbe3.svg";
export { ForwardRef as ReactComponent };